import React from 'react'

const ThePromise = ({ titleRef, isVisible, data }) => {
    return (
        <>
            <div className="text-start flex flex-col items-center pt-12 bg-[#fff8F5]  max-w-full mx-auto xs:px-5 z-10 max-sm:pt-3 " ref={titleRef}>
                <div
                    className={`mt-6 text-5xl font-bold leading-[58px] max-md:text-4xl text-orange-500 ${isVisible ? 'about-us_title_animation_fade_in_right' : ''}`}
                >
                    THE PROMISE
                </div>
                <div
                    className={`mt-6 text-5xl text-center font-medium leading-[58px] max-md:text-4xl ${isVisible ? 'about-us_title_animation_fade_in_right' : ''}`}
                >
                    "You will leave not with more information,<br />
                    but with more clarity, control and confidence."
                </div>


            </div>
        </>
    )
}

export default ThePromise
